import { Avatar, IconButton, Stack, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

import { ProfileAvatarProps } from "../types";

const ProfileAvatar = ({
  avatarPreview,
  firstName,
  lastName,
  onFileChange,
  onEditClick,
  fileInputRef,
}: ProfileAvatarProps) => {
  const theme = useTheme();

  return (
    <Stack position="relative" mb={3} alignItems="center">
      <Avatar
        src={avatarPreview}
        alt="Profile"
        sx={{
          width: 110,
          height: 110,
          bgcolor: theme.palette.grey[100],
          border: 1,
          borderColor: theme.palette.primary.main,
        }}
      >
        {`${firstName?.[0] || ""}${lastName?.[0] || ""}`}
      </Avatar>

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={onFileChange}
        style={{ display: "none" }}
      />
      <IconButton
        size="small"
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          backgroundColor: "white",
          boxShadow: 1,
        }}
        onClick={onEditClick}
      >
        <Icon icon="uil:edit" width={18} height={18} />
      </IconButton>
    </Stack>
  );
};

export { ProfileAvatar };
